// @flow

import {toast} from "react-toastify"
import i18n from "i18next"

import type {PlanningItem, Action, Dispatch, Token, GetState} from "../types"
import {put, del, post} from "../client"

export const setPlanning = (
  planning: $ReadOnlyArray<PlanningItem>
): Action => ({
  type: "SET_PLANNING",
  planning,
})

export const setPlanningBaby = (babyToken: ?Token): Action => ({
  type: "SET_PLANNING_BABY",
  babyToken,
})

export const addPlanningItem = (planningItem: PlanningItem) => {
  return (dispatch: Dispatch, getState: GetState) => {
    const {babyToken} = getState().planning
    const url = babyToken ? `/babies/${babyToken}/planning` : `/planning`
    return post(url, planningItem).then(response => {
      if (response.data) {
        dispatch(setPlanning(response.data))
      } else {
        toast.error(i18n.t("toast.planning.save.error"))
      }
    })
  }
}

export const markPlanningItemAsDone = (planningItem: PlanningItem) => {
  return (dispatch: Dispatch, getState: GetState) => {
    const planningData = {
      id: planningItem.id,
      key: planningItem.key,
      babyId: planningItem.babyId,
      isDone: true,
    }
    const {babyToken} = getState().planning
    const url = babyToken ? `/babies/${babyToken}/planning` : `/planning`
    return put(url, planningData).then(response => {
      if (response.data) {
        dispatch(setPlanning(response.data))
      } else {
        toast.error(i18n.t("toast.planning.put.error"))
      }
    })
  }
}

export const markAllPlanningItemsAsDone = (babyToken: Token) => {
  return (dispatch: Dispatch) => {
    return post(`/babies/${babyToken}/planning/mark_all_as_done`).then(
      response => {
        if (response.data) {
          dispatch(setPlanning(response.data))
        } else {
          toast.error(i18n.t("toast.planning.markAllAsDone.error"))
        }
      }
    )
  }
}

export const updatePlanningItem = (planningItem: PlanningItem) => {
  return (dispatch: Dispatch, getState: GetState) => {
    const planningData = {
      id: planningItem.id,
      key: planningItem.key,
      babyId: planningItem.babyId,
      description: planningItem.description,
      date: planningItem.date,
    }
    const {babyToken} = getState().planning
    const url = babyToken ? `/babies/${babyToken}/planning` : `/planning`
    return put(url, planningData).then(response => {
      if (response.data) {
        dispatch(setPlanning(response.data))
      } else {
        toast.error(i18n.t("toast.planning.put.error"))
      }
    })
  }
}

export const deletePlanningItem = (planningItem: PlanningItem) => {
  return (dispatch: Dispatch, getState: GetState) => {
    const planningData = {
      id: planningItem.id,
      babyId: planningItem.babyId,
    }
    const {babyToken} = getState().planning
    const url = babyToken ? `/babies/${babyToken}/planning` : `/planning`
    return del(url, planningData).then(response => {
      if (response.data) {
        dispatch(setPlanning(response.data))
      } else {
        toast.error(i18n.t("toast.planning.delete.error"))
      }
    })
  }
}
